import { useMemo } from "react";
import { useFormSelectQuery } from "../queries";

export const useSelectOptionsFromSlug = (slug: string, parentOptionsOnly?: boolean) => {
    const { getBySlugQuery } = useFormSelectQuery({ slug });
    const formSelect = getBySlugQuery.data;
    const formSelectOptions = formSelect?.formSelectOptions ?? [];
    const options = parentOptionsOnly
        ? formSelectOptions?.filter((o) => o.parentFormSelectOptionId === null)
        : formSelectOptions;

    return useMemo(
        () =>
            options
                .map((option) => ({
                    label: option.displayName,
                    value: option.value,
                }))
                .sort((a, b) => a.label.localeCompare(b.label)),
        [options]
    );
};
